import { ResponsePackageItem } from "../../../types/common";
import { StyleSheet } from "../../../StyleSheet";
import { Button, Card, Col, Row, Typography } from "antd";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import HireMegaMovilServicesComponent from "./HireMegaMovilServicesComponent";

const { Text } = Typography;

interface CollapsibleGroupProps {
    groupName: string;
    packages: ResponsePackageItem[];
    isExpanded: boolean;
    onToggle: () => void;
}

const CollapsibleGroupCard = (props: CollapsibleGroupProps) => {
    const { groupName, packages, isExpanded, onToggle } = props;

    return (
        <Row style={styles.wrapperRow}>
            <Card
                style={styles.cardRoot}
                bodyStyle={styles.cardBody}
            >
                <Row style={styles.headerRow}>
                    <Col flex="1">
                        <Text style={{ fontSize: 15, fontWeight: 'bold' }}>
                            {groupName}
                        </Text>
                    </Col>
                    <Col>

                        <Button
                            icon={
                                isExpanded ? (
                                    <UpOutlined style={{ color: "#797e84" }} />
                                ) : (
                                    <DownOutlined style={{ color: "#797e84" }} />
                                )
                            }
                            onClick={() => onToggle()}
                            type="text"
                        />
                    </Col>
                </Row>
                {
                    isExpanded && (
                        <Row style={styles.packagesRow}>
                            {packages.map((elem: ResponsePackageItem, key: number) => (
                                <>
                                    <Col span={24} key={`${groupName}-${elem.id || key}`} style={styles.packageItemContainer}>
                                        <HireMegaMovilServicesComponent packageSrv={elem} />
                                    </Col>
                                    {key !== packages.length - 1 &&
                                        <div style={styles.dividierStyle} />
                                    }
                                </>
                            ))}

                        </Row>
                    )
                }
            </Card >
        </Row >
    );

};
const styles = StyleSheet.create({
    wrapperRow: {
        marginBottom: 16,
        justifyContent: "center",
    },
    cardRoot: {
        boxShadow: "0px 0px 8px #00000029",
        borderRadius: 15,
        width: "95%",
    },
    cardBody: {
        borderRadius: 15,
        padding: 10
    },
    headerRow: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
    },
    headerText: {
        fontSize: 15,
        fontWeight: "bold",
    },
    icon: {
        color: "#797e84",
        fontSize: 16,
    },
    packagesRow: {
        marginTop: 8,
        justifyContent: "center",
        display: "flex",
    },
    packageItemContainer: {
        marginBottom: 8,
        padding: 10,
        width: "100%",
    },
    dividierStyle: {
        borderBottom: "1px solid #000000",
        width: "90%",
        // paddingTop: 15,
    }
});

export default CollapsibleGroupCard;